import { put, select, takeLatest } from 'redux-saga/effects'
import { getProcedureStateSelector } from '../../../../components/procedure/selectors'
import { setInputRows } from '../../../../components/procedure/store/procedure.actions'
import { IProcedureState } from '../../../../components/procedure/store/procedure.types'
import { getInitiateIvSelector } from '../selectors'
import { InitiateIvConstants } from '../store/initiateIv.constants'
import { IInitiateIvState } from '../store/initiateIv.types'

export function* setProcedureComplications() {
  const procedureState: IProcedureState = yield select(getProcedureStateSelector)
  const initiateIvState: IInitiateIvState = yield select(getInitiateIvSelector)
  const { inputRows } = procedureState
  const { procedureComplications } = initiateIvState
  inputRows.map((row) =>
    row.inputs.map((input) => {
      if (input.key === InitiateIvConstants.SET_PROCEDURE_COMPLICATIONS) {
        //@ts-ignore
        input.props.savedValues = procedureComplications
      }
    })
  )
  yield put(setInputRows(inputRows))
}

export function* setProcedureComplicationsSaga() {
  yield takeLatest([InitiateIvConstants.SET_PROCEDURE_COMPLICATIONS], setProcedureComplications)
}
